import React, {useEffect, useState, Fragment, useContext, useRef} from "react";

import {getMyTeams} from "root/DataFunctions/TeamDataFns";
import TeamDetailSidebarEntry from "root/Wieldy/Sidebar/TeamSidebar/TeamDetailSidebarEntry";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {useSetRecoilState} from "recoil";
import {teamIdAtom} from "root/recoil/teamId";
import TeamSidebarGroup from "root/Wieldy/Sidebar/TeamSidebar/TeamSidebarGroup";
import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";
import useModalAddTeam from "root/Modals/AddTeam/useModalAddTeam";
import {ApplicationTypes, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";
import GlobalContext, {useGlobalContext} from "root/contexts/GlobalContext";

const SidebarTeam = ({height, role}) =>
{
    const [teams, setTeams] = useState({loading: true, data: []});
    const setTeamId = useSetRecoilState(teamIdAtom);
    const { userType } = useGlobalContext() ;

    const sideNav = useRef ( null ) ;

    const getData = (response) => {
        getMyTeams('current', (response) =>
        {
            const teams = getDataFromResponse(response);

            setTeams({loading: false, data: teams});

            // Set the recoil teamIdAtom of the first team
            if (teams.length > 0)
            {
                setTeamId(teams[0].team_id);
            }
        });
    }

    useEffect(() => {
        getData();
    }, []);

    const teamList = () =>
    {
        return teams.data.map((team, index) => {
            return (
                <TeamDetailSidebarEntry keyName={team.team_id} teamDetails={team} iconName='icon-star'
                                        title={team.team_name} key={team.team_id} name={team.team_id}
                                        default={index === 0}/>
            )
        });
    }

    // Open add team modal
    const [renderAddTeamModal, showAddTeamModal] = useModalAddTeam((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    const clickHandler = (event) =>
    {
        showAddTeamModal('create');
    }

    const canManageAllTeams = doesUserHaveApplication(ApplicationTypes.ORGANISATION_ADMIN, userType)  ;

    const {top } = sideNav.current === null ? 0 : sideNav.current.getBoundingClientRect();

    const childContainerMaxHeight = (height - top) + 'px' ;

    return (
        <Fragment>
            <div className="dt-side-nav" ref={sideNav}>

                <div style={{maxHeight: childContainerMaxHeight, overflowY: 'scroll'}}>
                    <ul>
                        <TeamSidebarGroup title='My Teams' default='first' key='teams'>
                            {(teams.loading === false && teams.data.length > 0) && teamList()}
                        </TeamSidebarGroup>
                    </ul>
                </div>

                { canManageAllTeams && <WieldySidebarSection title='Add New Team' key='newTeam'>
                    <WieldySidebarClick modal={(event) => clickHandler(event)} title='Team' iconName='icon-add-circle'
                                        iconSize='icon-xl' keyName='root1' key='c1'/>
                </WieldySidebarSection> }

            </div>
            {renderAddTeamModal()}
        </Fragment>
    )
}

export default SidebarTeam;
